import { createSelector } from 'reselect';
import { getSizotsaFuneralCover } from './index';

export const getPurchasePersonalDetails = createSelector(
    getSizotsaFuneralCover,
    (sizotsaFuneralCover) => sizotsaFuneralCover.personalDetails
);

export const getPurchasePersonalDetailsForm = createSelector(
    getPurchasePersonalDetails,
    (personalDetails) => personalDetails.form
);

export const getPurchasePersonalDetailsReferenceData = () => ({
    titleList: [
        { description: 'Mr.', code: 'Mr.' },
        { description: 'Mrs.', code: 'Mrs.' },
        { description: 'Miss.', code: 'Miss.' },
    ],
    nationalities: [
        { description: 'Eswatini', code: 'Eswatini' },
        { description: 'Botswana', code: 'Botswana' },
        { description: 'South Africa', code: 'South Africa' },
        { description: 'Ghana', code: 'Ghana' },
        { description: 'Kenya', code: 'Kenya' },
        { description: 'Malawi', code: 'Malawi' },
        { description: 'Namibia', code: 'Namibia' },
        { description: 'Nigeria', code: 'Nigeria' },
        { description: 'Rwanda', code: 'Rwanda' },
        { description: 'South Sudan', code: 'South Sudan' },
        { description: 'Tanzania', code: 'Tanzania' },
        { description: 'Uganda', code: 'Uganda' },
        { description: 'Zimbabwe', code: 'Zimbabwe' },
    ],
    residencePeriod: [
        { description: 'Less than two years', code: 'Less than two years' },
        { description: 'More than two years', code: 'More than two years' },
    ],
    refrenceEmployeType: [
        { description: 'Employed', code: 'Employed' },
        { description: 'Self Employed', code: 'Self Employed' },
        { description: 'Unemployed', code: 'Unemployed' },
    ],
    refrenceSourceOfIncome: [
        { description: 'Employment', code: 'Employment' },
        { description: 'Self Employment', code: 'Self Employment' },
        { description: 'Pensions', code: 'Pensions' },
        { description: 'Asset Disposal', code: 'Asset Disposal' },
        { description: 'Investments ', code: 'Investments ' },
        { description: 'Inheritance', code: 'Inheritance' },
        { description: 'Loan ', code: 'Loan ' },
        { description: 'Other', code: 'Other' },
    ],
    referenceEmployeeOccupation:[
        { description: 'Health Care Provider', code: 'Health Care Provider' },
        { description: 'Pilot', code: 'Pilot' },
        { description: 'Accountant/audit', code: 'Accountant/audit' },
        { description: 'Banker', code: 'Banker' },
        { description: 'Lawyer', code: 'Lawyer' },
        { description: 'Diplomat', code: 'Diplomat' },
        { description: 'Pensioner', code: 'Pensioner' },
        { description: 'Risk And Compliance', code: 'Risk And Compliance' },
        { description: 'Manager', code: 'Manager' },
        { description: 'Cleaner ', code: 'Cleaner ' },
        { description: 'Military', code: 'Military' },
        { description: 'Scientist', code: 'Scientist' },
        // { description: 'Self Employed', code: 'Self Employed' },
        { description: 'Other', code: 'Other' },
    ]
});
const personalDetailLabels = {
    title: 'Title',
    // fullname: 'Full Name',
    nationality: 'Nationality',
    birthCountry: 'Birth Country',
    id: 'ID Number',
    expiryDate: 'ID Expiry Date',
    employementType: 'Employment Status',
    employeeOccupation: 'Occupation',
    otherEmployeeOccupation:'Other Occupation',
    sourceOfIncome: 'Source Of Income',
    otherSourceOfIncome:'Other Source Of Income',
    prominentPerson: 'Whether Politically Exposed Person?',
    dateOfBirth: 'Date Of Birth',

    workAddress: 'Place Of Work',
    mobileNumber: 'Cellphone Number',
    email: 'Email Address',
    telephoneWork: 'Telephone Work',
};

   
    
const addressDetailsLabels = {
    streetAddress: 'Plot number/suburb/ward',
    city: 'City/Town/Village',
    country: 'Country',
    residenceTimePeriod: 'How long have you been living in this address?',
    previousPostalAddress: 'Previous plot number/suburb/ward',
    previousPostalCity: 'Previous City/Town/Village',
    previousPostalCountry: 'Previous Country',
    postalSuburb: 'P O Box/Private Bag/Suburb/Ward',
    postalCity: 'Postal City/Town/Village',
    postalCountry: 'Postal Country',
};
export const getPersonalDetailsSummary = createSelector(
    getPurchasePersonalDetailsForm,
    (purchasePersonalDetailsForm) => {
        const { previousPostalAddress, previousPostalCity, previousPostalCountry, ...personalDetailFields } =
            purchasePersonalDetailsForm;

        const fullName = purchasePersonalDetailsForm['firstName']?.value + ' '+ (purchasePersonalDetailsForm['middleName']?.value ?? '') + ' ' + purchasePersonalDetailsForm['surname']?.value
        const personalDetails = Object.keys(personalDetailFields)?.map((item) => {
            return {
                label: personalDetailLabels[item],
                value: purchasePersonalDetailsForm[item]?.value ?? '-',
            };
        }).filter((({label})=> label));
        const addressDetails = Object.keys(
            purchasePersonalDetailsForm.residenceTimePeriod.value === 'Less than two years'
                ? purchasePersonalDetailsForm
                : personalDetailFields
        )?.map((item) => {
            return {
                label: addressDetailsLabels[item],
                value: purchasePersonalDetailsForm[item]?.value ?? '-',
            };
        }).filter((({label})=> label));
        const contactDetails = personalDetails.splice(-3, 2);
        return {
            personalDetails:[{label:'Full Name',value:fullName},...personalDetails],
            contactDetails,
            addressDetails,
        };
    }
);

export const getMainMemberTitle = createSelector(
    getPurchasePersonalDetailsForm,
    (form) => form?.title?.value
);

export const getSpouseTitleList = createSelector(
    getMainMemberTitle,
    (mainMemberTitle) => {
        const titleList= [
            { description: 'Mr.', code: 'Mr.' },
            { description: 'Mrs.', code: 'Mrs.' },
            { description: 'Miss.', code: 'Miss.' },
        ]
        return titleList.filter((list) =>
            mainMemberTitle === 'Mr.'
                ? list.description !== 'Mr.'
                : list.description === 'Mr.'
        );
    }
)